import { InputValidationModel } from '../../../Forms/models/input-validation.model';
import { LinkTypesEnum } from '../../../PageBuilder/enums/link-types.enum';

const VALID_URL = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@%!\$&'\(\)\*\+,;=.]+$/;

export const validateWebsiteURL = (url: string)  => {
    const trimmedUrl = url.trim();

    return VALID_URL.test(trimmedUrl);
};

export const TWITTER_URL_FORMAT = /http[s]?:\/\/(?:www\.)?(?:twitter|x)\.com\/(([A-Za-z0-9_]+)(?:\/|\?|$)|@?([A-Za-z0-9_]+))$/; // alphanumeric + _
export const INSTAGRAM_URL_FORMAT = /http[s]?:\/\/(?:www\.)?instagram\.com\/(([A-Za-z0-9\._]+)(?:\/|\?|$)|@?([A-Za-z0-9\._]+))$/; // alphanumeric + . _
export const FACEBOOK_URL_FORMAT = /http[s]?:\/\/(?:www\.)?facebook\.com\/(([A-Za-z0-9\.]+)(?:\/|\?|$)|@?([A-Za-z0-9\.]+))$/; // alphanumeric + .
export const YOUTUBE_URL_FORMAT = /http[s]?:\/\/(?:www\.)?youtube\.com\/(?:c)\/(([[A-Za-z0-9\.\-_]+)(?:\/|\?|$)|@?([A-Za-z0-9\.\-_]+))$/; // alphanumeric + .-
export const TIKTOK_URL_FORMAT = /http[s]?:\/\/(?:www\.)?tiktok\.com\/?@((?!.*\.\.)(?!.*\.$)[^\W][\w.]{2,24})$/; // alphanumeric . _ (but can't end in period)
export const LINKEDIN_URL_FORMAT = /http[s]?:\/\/(?:www\.)?linkedin\.com\/in\/([^\/\?\&]+).*/;
export const LINKEDIN_COMPANY_URL_FORMAT = /http[s]?:\/\/(?:www\.)?linkedin\.com\/company\/([^\/\?\&]+).*/;
export const LINKEDIN_BOTH_URL_FORMAT = new RegExp(
    LINKEDIN_URL_FORMAT.source + '|' + LINKEDIN_COMPANY_URL_FORMAT.source
);
export const SNAPCHAT_URL_FORMAT = /http[s]?:\/\/(?:www\.)?snapchat\.com\/add\/([^\/\?\&]+).*/;

export const handleValidationMap = {
    [LinkTypesEnum.twitter]: new InputValidationModel({
        requirements: TWITTER_URL_FORMAT,
        exclusions: null,
        errorKey: 'MediaSubscriptions.errors.badHandleFormat'
    }),
    [LinkTypesEnum.facebook]: new InputValidationModel({
        requirements: FACEBOOK_URL_FORMAT,
        exclusions: null,
        errorKey: 'MediaSubscriptions.errors.badHandleFormat'
    }),
    [LinkTypesEnum.instagram]: new InputValidationModel({
        requirements: INSTAGRAM_URL_FORMAT,
        exclusions: null,
        errorKey: 'MediaSubscriptions.errors.badHandleFormat'
    }),
    [LinkTypesEnum.youtube]: new InputValidationModel({
        requirements: YOUTUBE_URL_FORMAT,
        exclusions: null,
        errorKey: 'MediaSubscriptions.errors.badHandleFormat'
    }),
    [LinkTypesEnum.linkedin]: new InputValidationModel({
        requirements: LINKEDIN_BOTH_URL_FORMAT,
        exclusions: null,
        errorKey: 'MediaSubscriptions.errors.badHandleFormat'
    }),
    [LinkTypesEnum.snapchat]: new InputValidationModel({
        requirements: SNAPCHAT_URL_FORMAT,
        exclusions: null,
        errorKey: 'MediaSubscriptions.errors.badHandleFormat'
    }),
    [LinkTypesEnum.tiktok]: new InputValidationModel({
        requirements: TIKTOK_URL_FORMAT,
        exclusions: null,
        errorKey: 'MediaSubscriptions.errors.badHandleFormat'
    }),
    [LinkTypesEnum.website]: new InputValidationModel({
        isValid: validateWebsiteURL,
        errorKey: 'Amplify.fields.links.error.invalidWebsite'
    }),
};
